import { useQuery } from '@tanstack/react-query';
import type { FeatureKey, WorkspaceEntitlementsDto } from '@aiai/shared';
import { fetchWorkspaceEntitlements } from '../api';
import { useOrg } from '../org/useOrg';

/** The active workspace's resolved plan, features, quotas and usage (shared query key). */
export function useWorkspaceEntitlements() {
  const { activeOrg } = useOrg();
  return useQuery<WorkspaceEntitlementsDto>({
    queryKey: ['orgEntitlements', activeOrg?.id],
    queryFn: () => fetchWorkspaceEntitlements(activeOrg!.id),
    enabled: Boolean(activeOrg?.id),
  });
}

/** Is `key` on for the active workspace? `undefined` while loading. */
export function useFeature(key: FeatureKey): boolean | undefined {
  return useWorkspaceEntitlements().data?.features[key].enabled;
}
